export * from "./partner-dashboard-shell-template";
